import { Injectable } from '@angular/core';
import { WizardService } from '@smooved/ui';
import { Observable, of } from 'rxjs';

@Injectable()
export class SurveyWizardService extends WizardService {
    public loading$: Observable<boolean> = of();
}
